import { createSelector } from 'reselect';

import {
  TABS,
} from './constants';

const jobsSelector = (store) => store.apps.jobs;

/**
 * A Redux selector that returns the URL path for the currently selected cloudType ("vdc" or "rdc").
 * @returns {string="vdc","rdc"} - the URL path for the currently selected platform
 */
const cloudTypeTabSelector = createSelector([
  jobsSelector,
],
(jobs) => Object.keys(TABS).find((key) => TABS[key] === jobs.flatManual.get('cloudType')));

const containerSelector = createSelector([
  jobsSelector,
  (store, props) => props.match.params.username,
  // TODO: Find out why we set it based on props, and not
  // user.isOpenSauceUser() method
  (store, props) => props.isOpenSauceUser,
  (store) => store.user,
  (store, props) => props.isSubaccountDashboard,
  cloudTypeTabSelector,
],
(jobs, username, isOpenSauceUser, user, isSubaccountDashboard, cloudTypeTab) => ({
  cloudType: jobs.flatManual.get('cloudType'),
  cloudTypeTab,
  filters: jobs.filters,
  filtersInitialized: jobs.filters.get('filtersInitialized'),
  isOpenSauceUser: isOpenSauceUser || !user.isAuthenticated(),
  jobsTeamSharingFeatureEnabled: !isOpenSauceUser,
  jobsTeamSharingEnabled: jobs.users.get('user').organization.settings ?
    jobs.users.get('user').organization.settings.jobs_cross_team_sharing :
    true,
  organizationId: jobs.users.get('user').organization.id || user.organization.id,
  orgTeams: jobs.filters.get('orgTeams'),
  orgUsers: jobs.filters.get('orgUsers'),
  page: jobs.flatManual.get('page'),
  perPage: jobs.flatManual.get('perPage'),
  shouldFetchOrgUsers: !isOpenSauceUser && !isSubaccountDashboard && user.isAuthenticated(),
  user: jobs.users.get('user'),
  username: username || jobs.users.get('user').username,
}));

const launchNewTestButtonsSelector = createSelector([
  cloudTypeTabSelector,
  jobsSelector,
],
(cloudTypeTab, jobs) => ({
  cloudTypeTab,
  rdcJobs: jobs.flatManual.get('rdc'),
  vdcJobs: jobs.flatManual.get('manual'),
}));

const manualJobsSelector = createSelector([
  jobsSelector,
],
(jobs) => ({
  manual: jobs.flatManual.get('manual'),
  manualLoading: jobs.flatManual.get('manualLoading'),
  rdc: jobs.flatManual.get('rdc'),
  rdcLoading: jobs.flatManual.get('rdcLoading'),
  totalJobs: jobs.flatManual.get('totalJobs'),
}));

export default containerSelector;
export {
  cloudTypeTabSelector,
  containerSelector,
  launchNewTestButtonsSelector,
  manualJobsSelector,
};
